<template>
  <div>
    <el-form class="editForm" label-position="top">
      <el-form-item class="position" label="题干">
        <div class="content" id="content-ueditor" @click="changeEditor" ref="content">
          <script
            id="queUEditor"
            class="queUEditor"
            name="content"
            type="text/plain"
            style="width: 100%; height: 120px"></script>
        </div>
      </el-form-item>
      <el-form-item class="must" v-if="question.Options && question.Options.length > 0">
        <div slot="label">
          <span>选项</span>
        </div>
        <div v-for="(option, oindex) of question.Options" :key="oindex">
          <p>选项{{ optNums[oindex] }}</p>
          <div ref="options" class="content" :id="'option' + oindex" v-html="option" @click="changeEditor"></div>
        </div>
      </el-form-item>
      <el-form-item class="must" label="答案">
        <div v-if="question.Data.CateName == '选择题'">
          <el-radio-group v-model="Answers[0]" ref="answers">
            <el-radio v-for="(option, oindex) of question.Options" :label="oindex + ''" :key="'answer' + oindex">
              {{ optNums[oindex] }}
            </el-radio>
          </el-radio-group>
        </div>
        <div v-else-if="question.Data.CateName == '多选题'">
          <el-checkbox-group v-model="Answers" ref="answers">
            <el-checkbox v-for="(option, oindex) of question.Options" :label="oindex + ''" :key="'answer' + oindex">
              {{ optNums[oindex] }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-else-if="question.Data.CateName == '判断题'">
          <el-radio-group v-model="Answers[0]" ref="answers">
            <el-radio label="T">对</el-radio>
            <el-radio label="F">错</el-radio>
          </el-radio-group>
        </div>
        <div
          v-else
          class="content"
          id="answer-ueditor"
          ref="displayAnswer"
          v-html="question.Data.DisplayAnswer"
          @click="changeEditor"></div>
      </el-form-item>
      <el-form-item label="分析">
        <div
          class="content"
          id="analyse-ueditor"
          ref="analyse"
          @click="changeEditor"
          v-html="question.Data.Analyse"></div>
      </el-form-item>
      <el-form-item label="解答">
        <div class="content" id="method-ueditor" ref="method" @click="changeEditor" v-html="question.Data.Method"></div>
      </el-form-item>
      <el-form-item>
        <div style="text-align: center; margin-top: 0">
          <el-button v-if="saveAndPush" :disabled="btnDisable" size="mini" type="primary" @click="saveQuestion">
            保存并推送
          </el-button>
          <el-button v-else :disabled="btnDisable" size="mini" type="primary" @click="saveQuestion">保存题目</el-button>
          <el-button :disabled="btnDisable" size="mini" type="warning" @click="handleCancle">取消编辑</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: "QuestionBankEdit",
  props: {
    question: null,
    saveAndPush: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optNums: ["A", "B", "C", "D", "E", "F", "G"],
      Answers: [],
      btnDisable: false,
      ue: null,
    };
  },
  mounted() {
    // this.Answers = this.question.Answers;
    let answers = this.question.Answers;
    this.Answers = [];
    this.Answers = this.Answers.concat(answers);
    
    // UEditor 安全配置
    const secureConfig = {
      serverUrl: window.hosturl + "/UEditor/Handler",
      // 限制文件大小
      imageMaxSize: 5 * 1024 * 1024,  // 5MB
      videoMaxSize: 50 * 1024 * 1024, // 50MB
      fileMaxSize: 10 * 1024 * 1024,  // 10MB
      // 限制文件类型
      imageAllowFiles: ['.jpg', '.jpeg', '.png', '.gif', '.bmp'],
      videoAllowFiles: ['.mp4', '.avi', '.wmv', '.flv'],
      fileAllowFiles: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt'],
      // 禁用远程图片抓取（防止 SSRF 攻击）
      catchRemoteImageEnable: false,
      // 禁用图片管理和文件管理（防止信息泄露）
      imageManagerActionName: '',
      fileManagerActionName: '',
      // XSS 过滤
      xssFilterRules: true,
      inputXssFilter: true,
      outputXssFilter: true
    };
    
    this.ue = UE.getEditor("queUEditor", secureConfig);
    
    // let that = this;
    this.ue.ready(() => {
      this.ue.setContent(this.question.Data.Content);
      this.ue.addListener("contentChange", () => {
        this.$emit("input", this.ue.getContent());
      });
      //阻止工具栏的点击向上冒泡
      this.ue.addListener("onclick", (e) => {
        e.stopPropagation();
      });
      
      // 监听图片插入前事件，验证图片来源
      this.ue.addListener('beforeInsertImage', (t, args) => {
        // 过滤非本站图片
        const filteredArgs = args.filter(url => {
          return url.startsWith(window.hosturl) || url.startsWith('/uploads') || url.startsWith('/net');
        });
        if (filteredArgs.length !== args.length) {
          this.$message.warning('已过滤非本站图片');
        }
        return filteredArgs;
      });
    });
  },
  beforeDestroy() {
    if (this.ue) {
      this.ue.destroy();
    }
  },
  watch: {
    question(newQue, oldQue) {
      console.log(newQue);
      let answers = newQue.Answers;
      this.Answers = [];
      this.Answers = this.Answers.concat(answers);
    },
  },
  methods: {
	  /* 获取一段HTML文本中的纯文本内容 */
	  htmlToText(html) {
		// 创建一个新的DOMParser实例
		var parser = new DOMParser();
  
		// 使用DOMParser的parseFromString方法将HTML字符串转换为Document对象
		var doc = parser.parseFromString(html, "text/html");
  
		// 定义一个函数来递归提取所有文本节点的内容
		function extractText(node) {
		  var text = "";
		  if (node.nodeType === Node.TEXT_NODE) {
			text += node.textContent;
		  } else if (node.nodeType === Node.ELEMENT_NODE) {
			for (var i = 0; i < node.childNodes.length; i++) {
			  text += extractText(node.childNodes[i]);
			}
		  }
		  return text;
		}
  
		// 从Document对象的body开始提取文本
		return extractText(doc.body);
	  },
    saveQuestion() {
      let formData = { ID: this.question.Data.ID };
      // 获取题干内容，封装表单数据
      let contentElem = this.$refs.content;
      console.log(contentElem);
      let content;
      if (contentElem.querySelector(".queUEditor")) {
        content = UE.getEditor("queUEditor").getContent();
      } else {
        content = contentElem.innerHTML;
      }
	  if ((this.htmlToText(content) != "" && this.htmlToText(content) != "请输入内容") || content.indexOf("img") != -1 ) {
		content = content.substring(content.indexOf('>') + 1, content.length - 4);
	  } else {
		content = "";
	  }
      formData.Content = content;
      // 获取选项内容，封装表单数据
      let options = [];
      if (this.$refs.options) {
        for (let optionElem of this.$refs.options) {
          let option;
          if (optionElem.querySelector(".queUEditor")) {
            option = UE.getEditor("queUEditor").getContent();
          } else {
            option = optionElem.innerHTML;
          }
		  if ((this.htmlToText(option) != "" && this.htmlToText(option) != "请输入内容") || option.indexOf("img") != -1 ) {
			option = option.substring(option.indexOf('>') + 1, option.length - 4);
		  } else {
		    option = "";
		  }
          options.push(option);
        }
        formData.Options = options;
      }

      // 获取答案信息，封装表单数据
      let displayAnswer = "";
      if (this.$refs.answers) {
        // 客观题（单选、多选、判断）
        for (let aindex of this.Answers) {
          displayAnswer.concat(this.optNums[Number(aindex)]);
        }
        formData.Answers = this.Answers;
        formData.DisplayAnswer = displayAnswer;
      } else {
        // 非客观题
        let displayAnswerElem = this.$refs.displayAnswer;
        console.log(displayAnswerElem);
        if (displayAnswerElem.querySelector(".queUEditor")) {
          displayAnswer = UE.getEditor("queUEditor").getContent();
        } else {
          displayAnswer = displayAnswerElem.innerHTML;
        }
		if ((this.htmlToText(displayAnswer) != "" && this.htmlToText(displayAnswer) != "请输入内容") || displayAnswer.indexOf("img") != -1 ) {
		  displayAnswer = displayAnswer.substring(displayAnswer.indexOf('>') + 1, displayAnswer.length - 4);
		} else {
		  displayAnswer = "";
		}
        formData.DisplayAnswer = displayAnswer;
        Answers = displayAnswer.join(",");
        formData.Answers = Answers;
      }
      // 获取分析内容，封装表单数据
      let analyseElem = this.$refs.analyse;
      let analyse;
      if (analyseElem.querySelector(".queUEditor")) {
        analyse = UE.getEditor("queUEditor").getContent();
      } else {
        analyse = analyseElem.innerHTML;
      }
	  if ((this.htmlToText(analyse) != "" && this.htmlToText(analyse) != "请输入内容") || analyse.indexOf("img") != -1 ) {
		analyse = analyse.substring(analyse.indexOf('>') + 1, analyse.length - 4);
	  } else {
	    analyse = "";
	  }
      formData.Analyse = analyse;
      // 获取解答内容，封装表单数据
      let methodElem = this.$refs.method;
      let method;
      if (methodElem.querySelector(".queUEditor")) {
        method = UE.getEditor("queUEditor").getContent();
      } else {
        method = methodElem.innerHTML;
      }
	  if ((this.htmlToText(method) != "" && this.htmlToText(method) != "请输入内容") || method.indexOf("img") != -1 ) {
		method = method.substring(method.indexOf('>') + 1, method.length - 4);
	  } else {
	    method = "";
	  }
      formData.Method = method;
      // 提交表单数据
      this.axios
        .post(
          window.hosturl + "/rest/questionBank/PushQuestionEdition",
          formData
        )
        .then(res => {
          if (res.data.result == 200) {
            this.$message.success("已保存！！！");
            this.question.Data.Content = content;
            this.question.Data.DisplayAnswer = displayAnswer;
            this.question.Data.Analyse = analyse;
            this.question.Data.Method = method;
            this.question.Options = options;
            this.question.Answers = this.Answers;
            this.$emit("save", this.question);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    handleCancle() {
      this.$emit("cancel");
    },
    changeEditor(e) {
      let ue = this.ue;
      var target = e.target;
      var content = target.innerHTML;
      console.log(content);

      var currentParnet = ue.container.parentNode.parentNode;
      var currentContent = ue.getContent();
      console.log(ue.getContent());
      if (currentContent.indexOf("<p>") == 0) {
        currentContent = currentContent.substring(3, currentContent.length - 4);
      }

      target.innerHTML = "";
      ue.execCommand("cleardoc");
      target.append(ue.container.parentNode);
      ue.reset();

      if (content) {
        setTimeout(function () {
          ue.setContent(content);
        }, 200);
      }

      console.log(ue.getContent());
      currentParnet.innerHTML = currentContent;
    },
  },
};
</script>
<style lang="less">
.content {
  min-height: 40px;
  border: 1px solid #e0e0e0;
  padding: 2px;
}
.editForm .el-form-item {
  margin-bottom: 10px;
}
.editForm.el-form--label-top .el-form-item__label {
  padding: 0;
  color: #2489f6;
}
p {
  margin: 0;
  padding: 0;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/QuestionBankEdit.vue